import React from 'react';

export default () => (
  <>
    If you like what you see here, you’ll love our newsletters. We send regular content including articles, blogs, quotes, all dedicated to getting you thinking, dreaming, brainstorming, and planning your next steps toward whichever goal is on your radar. Sometimes all it takes is a little inspiration—if that is what you need, we’re here to deliver!
  </>
)
